export default __webpack_public_path__ + "static/media/PowerPoleWallDouble_MK1.256.80a665f4.png";